import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/dobovoActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchDobovoOrganizations = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.DOBOVO_ORGANIZATIONS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.dobovoOrganizations, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_fetchOrganizationsSuccess(getParser(urls.dobovoOrganizations)(json))))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}

/** @thunk **/
export const postDobovoOrganization = organization => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organization)
    }
    const { auth } = getState()

    securedFetch(urls.dobovoOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_saveOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация добавлена'))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_saveOrganizationsFailure,
                'Что-то пошло не так!',
                'При сохранении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const updateDobovoOrganization = (remoteId, payload) => (dispatch, getState) => {
    // prettier-ignore
    const { auth, dobovoOrganizations: { entities: { organizations } } } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...organizations[remoteId], ...payload })
    }

    securedFetch(urls.dobovoOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.dobovo_updateOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация обновлена'))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_updateOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteDobovoOrganization = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.dobovoOrganizationSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.dobovo_deleteOrganizationSuccess(remoteId)))
        .then(() => toastr.success('Организация удалена'))
        .catch(
            handleError(
                dispatch,
                actions.dobovo_deleteOrganizationFailure,
                'Что-то пошло не так!',
                'При удалении организации произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/dobovoApi/dobovoOrganizations.js